const COUNTRIES = [
  {
    id: 'de',
    name: 'Deutschland',
  },
  {
    id: 'at',
    name: 'Österreich',
  },
];

export default COUNTRIES;
